export enum ApplicationHiddenRole {
    nirvanaAdmin = "nirvanaAdmin", // OV only
}

export enum ApplicationPublicRole {
    practiceUser = "practiceUser", // deprecated
    practiceOwner = "practiceOwner", // OV only
    practiceAdmin = "practiceAdmin", //OV only
    practiceBiller = "practiceBiller", // OV only
}

export enum OneVerifyApplicationRole {
    nirvanaAdmin = ApplicationHiddenRole.nirvanaAdmin,
    practiceOwner = ApplicationPublicRole.practiceOwner,
    practiceAdmin = ApplicationPublicRole.practiceAdmin,
    practiceBiller = ApplicationPublicRole.practiceBiller,
}

export enum LabelingApplicationRole {
    readOnly = "readOnly",
    biller = "biller",
    billerPlus = "billerPlus",
    supervisor = "supervisor",
    admin = "admin",
}

export enum PermissionsExistenceLogicalOperator {
    AND = "AND",
    OR = "OR",
}

export enum OneVerifyPermission {
    useEagleEye = "useEagleEye", // feature that allows to act as other user
    useComingSoonFeatures = "useComingSoonFeatures", // permission to see features in the system that are not released yet, but will be soon

    runCoverageChecks = "runCoverageChecks",
    runCsvBulkCoverageChecks = "runCsvBulkCoverageChecks",
    reportCoverageCheck = "reportCoverageCheck",
    managePracticeUsers = "managePracticeUsers",
    readPracticeConfigurations = "readPracticeConfigurations",
    managePracticeConfigurations = "managePracticeConfigurations",
    transferPracticeOwnership = "transferPracticeOwnership",
    manageBilling = "manageBilling",
    manageBillerGroups = "manageBillerGroups",
    viewHistoricalCoverageChecks = "viewHistoricalCoverageChecks",
    overrideCoverageData = "overrideCoverageData",
    receivePracticeWideSocketsEvents = "receivePracticeWideSocketsEvents",
    viewPlanYearResets = "viewPlanYearResets",
    managePracticeWideSavedFilters = "managePracticeWideSavedFilters",
    manageTaskAssignments = "manageTaskAssignments",
    workTaskAssignments = "workTaskAssignments",
    filterByOrganizationUsers = "filterByOrganizationUsers",
    manageNetworkStatusRules = "manageNetworkStatusRules",
    viewPracticeInsights = "viewPracticeInsights",
    managePracticeIntegrations = "managePracticeIntegrations",
}

export enum LabelingPortalPermission {
    // TODO define more when needed
    listProjects = "listProjects", // if user has this permission, main view is project based
    manageProjects = "manageProjects",

    annotateTasks = "annotateTasks",
    annotateTasksWithoutDoubleAnnotations = "annotateTasksWithoutDoubleAnnotations",
    annotateAllTasks = "annotateAllTasks",
    listAllTasks = "listAllTasks", // list all tasks in the system, not only assigned
    manageTasks = "manageTasks",
    exportTasks = "exportTasks",
    // if doesn't have this permission, will get only own comments + comments of supervisors / managers
    listAllTaskComments = "listAllTaskComments",
    addTaskComments = "addTaskComments",

    listAllTaskCommentsInReview = "listAllTaskCommentsInReview",
    listAllAnnotationsInReview = "listAllAnnotationsInReview",

    // if user has this permission, can view annotations of other users
    // not only from themselves and supervisors / managers
    listAllAnnotations = "listAllAnnotations",
    resolveAnnotationsConflicts = "resolveAnnotationsConflicts",

    manageUsers = "manageUsers",

    listBillersStats = "listBillersStats",
    listAllUsersStats = "listAllUsersStats",

    manageBillerGroups = "manageBillerGroups",
    canBeBillerGroupLead = "canBeBillerGroupLead",
}

export const COMMON_ROLES_PERMISSIONS_CONFIG = {}
